import React from 'react';
import { FileText, CheckCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Separator } from '@/components/ui/separator';
import { Alert, AlertDescription } from '@/components/ui/alert';
import RichTextEditor from '@/components/RichTextEditor';

export const TemplatesTab = ({ settings, handleChange }) => (
  <Card className="bg-white border-slate-200">
    <CardHeader>
      <CardTitle className="text-slate-900 flex items-center gap-2">
        <FileText className="w-5 h-5 text-indigo-700" />
        Templates Legais Globais
      </CardTitle>
      <CardDescription className="text-slate-500">
        Estes templates são copiados para o rodapé de <strong>cada novo tenant</strong>
        no momento da criação. Cada tenant pode personalizá-los depois em
        <em> Admin → Definições → Rodapé</em>. Ao alterar aqui, os tenants
        existentes <strong>não são afetados</strong> (podem restaurar-se manualmente com
        o botão &quot;Restaurar do template global&quot; na página de definições do tenant).
      </CardDescription>
    </CardHeader>
    <CardContent className="space-y-8">
      <div className="space-y-2">
        <Label className="text-base font-semibold">Política de Privacidade (Template)</Label>
        <RichTextEditor
          value={settings.default_privacy_policy_content || ''}
          onChange={(html) => handleChange('default_privacy_policy_content', html)}
          placeholder="Cole ou escreva o modelo base de política de privacidade…"
          testid="default-privacy-editor"
        />
        <Input
          placeholder="OU: link externo (opcional)"
          value={settings.default_privacy_policy_url || ''}
          onChange={(e) => handleChange('default_privacy_policy_url', e.target.value)}
          className="bg-white border-slate-300 text-slate-900"
          data-testid="default-privacy-url-input"
        />
      </div>

      <Separator />

      <div className="space-y-2">
        <Label className="text-base font-semibold">Termos de Utilização (Template)</Label>
        <RichTextEditor
          value={settings.default_terms_of_use_content || ''}
          onChange={(html) => handleChange('default_terms_of_use_content', html)}
          placeholder="Cole ou escreva o modelo base de termos de utilização…"
          testid="default-terms-editor"
        />
        <Input
          placeholder="OU: link externo (opcional)"
          value={settings.default_terms_of_use_url || ''}
          onChange={(e) => handleChange('default_terms_of_use_url', e.target.value)}
          className="bg-white border-slate-300 text-slate-900"
          data-testid="default-terms-url-input"
        />
      </div>

      <Alert className="bg-blue-50 border-blue-200">
        <CheckCircle className="w-4 h-4 text-blue-600" />
        <AlertDescription className="text-blue-800">
          Novos tenants criados após guardar herdam automaticamente estes templates.
          Tenants existentes só recebem se o admin do tenant clicar &quot;Restaurar do template global&quot;.
        </AlertDescription>
      </Alert>
    </CardContent>
  </Card>
);
